import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor() {
  }

  currentCountry$ = new BehaviorSubject<string>('');
  shareTwitterText$ = new BehaviorSubject<string>('');

  selectedCheckboxCountries$ = new BehaviorSubject<string[]>([]);

  isInVaccineComponent = new BehaviorSubject<boolean>(false);
  isInVaccineComponent$ = this.isInVaccineComponent.asObservable();

  setTweetText(): void {
    const text = 'Check the Covid-19 progress in ' + this.currentCountry$.getValue() + ' at https://ng-covid19.netlify.app/country/'
      + this.currentCountry$.getValue();
    this.shareTwitterText$.next(text);
  }


}
